import WsService from "../WsService";
import BankAccountDTO from "../../domain/Registration/BankAccountDTO";

const ENDPOINT_BASE = "/bank-account";

export default class BankAccountService {

    static linkBankCardToBankAccount(barcode, registrationId, cardFee) {

        let endpoint = ENDPOINT_BASE + "/link-bank-card-to-bank-account";

        let jsonObj = {};
        jsonObj["barcode"] = barcode;
        jsonObj["registrationId"] = registrationId;
        jsonObj["cardFee"] = cardFee;

        return WsService.put(endpoint, jsonObj, 200).then(
            response => {
                return new BankAccountDTO(response);
            },
            response => {
                return response;
            });
    }
}
